module.exports = __webpack_public_path__ + "img/lcht.ceae2a1e.png";